import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import {
    getDashboardData,
    getUsers,
    getTodayAttendanceTime,
    getEmployeeData,
} from '../../store/configureStore';
import { getFormattedTiming } from '../../common/utils';

/**
 * Dispatches initial data fetches when Auth0 is used. Mounted inside UserIdResolver,
 * so the token getter is already set and API calls will include the Authorization header.
 */
const InitDataFetcher = () => {
    const dispatch = useDispatch();
    const hasFetched = useRef(false);

    useEffect(() => {
        if (hasFetched.current) return;
        hasFetched.current = true;

        dispatch(getDashboardData());
        dispatch(getUsers());
        dispatch(getTodayAttendanceTime(getFormattedTiming(new Date())));
        dispatch(getEmployeeData());
    }, [dispatch]);

    return null;
};

export default InitDataFetcher;
